namespace GeniuzPOS.AdvPromo {
    export enum amtorpc3Fg {
        amtorpcFg3Fg1 = 1,
        amtorpcFg3Fg2 = 2
    }
    Serenity.Decorators.registerEnumType(amtorpc3Fg, 'GeniuzPOS.AdvPromo.amtorpc3Fg');
}
